import React from "react";
import { useInformation } from "../../../hooks/information/useInformation";

export const InformationDetail = React.memo(function InformationDetail() {
    const information = useInformation();

    return information ? (
        <div className={"content"}>
            <div className="content__date">
                <p>{information.createdTime.date.format("/")}</p>
            </div>
            <div className="content__title">
                <p>{information.title.value}</p>
            </div>
            <div className="content__body">
                {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
                <div dangerouslySetInnerHTML={{ __html: information.content.value.replace(/[\n\r]/g, "<br />") }} />
            </div>
        </div>
    ) : <></>;
});
